import { CreateRemixError } from 'types/remixes';
import { createRemix } from './api/community_api';
import { navigateTo } from './utils';

/**
 * Creates a remix and opens the resulting file in the editor
 * @param revisionId Revision id we are creating the remix for
 * @returns
 */
export async function createRemixAndOpen(
  teamId: number,
  revisionId: number,
  name: string
) {
  // @ts-ignore
  const isSafari = window.safari !== undefined;

  // Safari will block any window.open calls made in an async function. This is
  // a work around from here: https://stackoverflow.com/a/39387533.
  let windowRef;
  if (isSafari) {
    windowRef = window.open();
  }

  const remixResponse = await createRemix(teamId, revisionId, name);
  if (remixResponse.error !== undefined) {
    if (remixResponse.error === CreateRemixError.authentication) {
      // TODO: we want to show a modal pop up here instead
      navigateTo('/login');
      return;
    }
  }

  // TODO: we want a modal to pop up to let them know a file has been
  // created, but for now we punt them to the editor
  const remix = remixResponse.remix!;
  const fileUrl = `${process.env.NEXT_PUBLIC_EDITOR}/file/${remix.fileNameSlug}/${remix.fileId}`;

  if (isSafari && windowRef) {
    windowRef.location = fileUrl;
  } else {
    window.open(fileUrl, '_blank', 'noopener,noreferrer');
  }
  return remix;
}
